import Cookies from 'js-cookie';
import Base from './base';

class FormFiltersReinitiate extends Base {
	start() {
		this.on('click');
	}

	onClick(e) {
		const { target } = e;

		if (target !== this.refs.close) {
			return;
		}

		this.close();
	}

	close() {
		this.removeCookie();
		this.removeElement();
	}

	removeElement() {
		this.el.parentNode.removeChild(this.el);
	}

	removeCookie() {
		const { dataset: { cookieKey } } = this.el;

		Cookies.remove(cookieKey, { path: '/' });
	}
}

export default FormFiltersReinitiate;
